export const packages = [
  {
    name: 'Basic',
    price: '500',
    features: [
      'Maandelijkse opschoning',
      'Datakwaliteit-check',
      'Rapportage bijhouden',
      'E-mail support'
    ],
    ideal: 'Kleine teams'
  },
  {
    name: 'Pro',
    price: '1.500',
    features: [
      'Alles van Basic',
      'Wekelijkse checks',
      'Gebruikerssupport',
      'CRM-aanpassingen',
      'Maandrapportage'
    ],
    ideal: 'MKB / SaaS',
    popular: true
  },
  {
    name: 'Premium',
    price: '2.500',
    features: [
      'Alles van Pro',
      'Proactieve verbeteringen',
      'Datamigraties (light)',
      'SLA-afspraken',
      'Sparring sales/ops'
    ],
    ideal: 'Scale-ups'
  }
];
